import styled from 'styled-components';
import AlertDialog from './AlertDialog';

const WidthDiv = styled.div`
  width: 300px;
`;

type Props = { success: string; error: string; onClose: (wasAccepted: boolean) => void };
export const SuccessErrorDlg = (props: Props) => {
  const { error, success, onClose } = props;
  let subtitle = success || error ? <WidthDiv>{success || error}</WidthDiv> : undefined;
  let icon: 'success' | 'error' | undefined;

  if (success) {
    icon = 'success';
  } else if (error) {
    icon = 'error';
  } else {
    icon = undefined;
  }

  return (
    <AlertDialog
      show={!!success || !!error}
      title={'Concursar'}
      subtitle={subtitle}
      icon={icon}
      btns={['accept', 'close']}
      onClose={onClose}
    />
  );
};
